import Vue from "vue";
import Vuex from "vuex";
import {
	storage,
	sessionstorage,
	storageKey
} from "@/utils/storage";
import {
	getShoppingCart,
	reduce,
	addCart,
	getReview,
	update
} from "@/api";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		// s: process.env.VUE_APP_SIGN,
		// p: process.env.VUE_APP_PHONE,
		sign: sessionstorage.get(storageKey.SIGN),
		phone: sessionstorage.get(storageKey.PHONE),
		shoppingCart: null, //购物车信息
		coupons: null, //店铺优惠券
		city: storage.get(storageKey.CITY), //当前城市
		store: storage.get(storageKey.STORE), //上次选择门店
		paycard: storage.get(storageKey.PAYCARD), //获取是否支付星礼卡
		cardNum:storage.get(storageKey.CARDNUM),
	},

	getters: {
		// 获取数量
		getCartNumber(state) {
			if (!state.shoppingCart) {
				return 0;
			}

			var cart = state.shoppingCart["Shopping_Cart"];
			var num = 0;
			for (var item of cart) {
				num += parseInt(item["qty"]);
			}

			return num;
		},
		getShoppingCart: (state) => state.shoppingCart,
		getCity: (state) => state.city,
		getStore: (state) => state.store,
		getSign: (state) => state.sign,
		getPhone: (state) => state.phone,
		getpaycard: (state) => state.paycard,
		getcardNum: (state) => state.cardNum,
	},

	mutations: {
		setcardNum(state, val) {
			state.cardNum = val;
			sessionStorage.setItem(storageKey.CARDNUM, val)
		},
		setpaycard(state, val) {
			state.paycard = val;
			sessionStorage.setItem(storageKey.PAYCARD, val)
		},
		setSign(state, val) {
			state.sign = val;
			sessionStorage.setItem(storageKey.SIGN, val)
		},
		setPhone(state, val) {
			state.phone = val;
			sessionStorage.setItem(storageKey.PHONE, val)
		},
		setStore(state, val) {
			storage.set(storageKey.STORE, val);
			state.store = val;
		},
		setCity(state, val) {
			storage.set(storageKey.CITY, val);
			state.city = val;
		},
		setShoppingCart(state, val) {
			state.shoppingCart = val;
		},
		delShoppingCart(state, val) {
			var _index = state.shoppingCart["Shopping_Cart"].findIndex(
				(d) => d.id == val.id
			);
			state.shoppingCart["Shopping_Cart"].splice(_index, 1);
		},
	},
	actions: {
		// update
		/**
		 * 修改商品
		 * @param {*} param0
		 * @param {*} _data
		 * @returns
		 */
		reduceShoppingCart({
			dispatch,
			getters,
			commit
		}, _data) {
			var data = JSON.parse(JSON.stringify(_data["data"]));
			var num = _data["num"];

			data["qty"] = parseInt(data["qty"]) + num;
			// 商品数量为0从购物车中删除商品
			if (data["qty"] <= 0) {
				return reduce(data["cart_product_id"]).then(() => {
					commit("delShoppingCart", data);
					dispatch("getShoppingCart", _data);
				});
			} else {
				var _updateForm = {
					add_extra: data["add_extra"],
					cart_product_id: data["cart_product_id"],
					id: data["id"],

					qty: data["qty"],
					store_id: getters.getStore.id,

					sku: data["sku"] || data["spec_id"],
					spec_id: data["spec_id"],
					spec_sku: data["spec_sku"],
				};

				return update(_updateForm).then(() => {
					dispatch("getShoppingCart");
				});
			}
		},

		addShoppingCart({
			dispatch
		}, data) {
			return addCart(data).then((d) => {
				dispatch("getShoppingCart");
				console.log(d);
			});
		},
		// getReview
		getCoupons() {
			return getReview().then((d) => {
				console.log(d);
			});
		},
		getShoppingCart({
			commit
		}) {
			return getShoppingCart().then((d) => {
				commit("setShoppingCart", d.data);
			});
		},
	},
	modules: {},
});